'use strict';

angular.module('app.segmentationReportInfluencerOverview', [])
    .directive('segmentationReportInfluencerOverviewDirective', function () {
        return {
            controller: 'segmentationReportInfluencerOverviewCtrl',
            templateUrl: 'app/measure/segmentationReport/segmentationReportInfluencerOverview/segmentationReportInfluencerOverview.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })